const AlertModal = ({ isOpen, message, onConfirm, onCancel, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-md shadow-lg p-6 w-[90%] max-w-md">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Warning</h2>
        <p className="text-sm text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end gap-4">
          {!isLoading && (
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition"
            >
              Cancel
            </button>
          )}
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-sm rounded-md ${isLoading
                ? "bg-gray-500 text-gray-200 cursor-not-allowed"
                : "bg-red-600 text-white hover:bg-red-700 transition"
              }`}
            disabled={isLoading}
          >
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal